import { IRoute } from '../utils';
import PartList from './list';

const Route: IRoute = {
  path: '/parts',
  label: 'parts',
  component: PartList,

  routes: [
    {
      path: '/:partKey',
      component: PartList
    }
  ]
};

export default Route;
